import { RenderableBase } from './renderable-base';

export class RenderableRichText extends RenderableBase<string> {
}
